import { OperationParameter, OperationURLParameter } from "@azure/core-client";
import { VoucherCodeApplyRequest as VoucherCodeApplyRequestMapper } from "../models/mappers";

export const contentType: OperationParameter = {
  parameterPath: ["options", "contentType"],
  mapper: {
    defaultValue: "application/json",
    isConstant: true,
    serializedName: "Content-Type",
    type: {
      name: "String"
    }
  }
};

export const body: OperationParameter = {
  parameterPath: ["options", "body"],
  mapper: VoucherCodeApplyRequestMapper
};

export const accept: OperationParameter = {
  parameterPath: "accept",
  mapper: {
    defaultValue: "application/json",
    isConstant: true,
    serializedName: "Accept",
    type: {
      name: "String"
    }
  }
};

export const $host: OperationURLParameter = {
  parameterPath: "$host",
  mapper: {
    serializedName: "$host",
    required: true,
    type: {
      name: "String"
    }
  },
  skipEncoding: true
};

export const basketId: OperationParameter = {
  parameterPath: "basketId",
  mapper: {
    serializedName: "basketId",
    required: true,
    type: {
      name: "String"
    }
  }
};

export const openIDToken: OperationParameter = {
  parameterPath: "openIDToken",
  mapper: {
    serializedName: "openIDToken",
    required: true,
    type: {
      name: "String"
    }
  }
};
